import { Component, OnInit, enableProdMode, OnDestroy } from '@angular/core';
import {
  Router,
  Event,
  NavigationStart,
  NavigationCancel,
} from '@angular/router';

if (!/localhost/.test(document.location.host)) {
  enableProdMode();
}

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit {
  canBeShown = true;
  currentUser;
  routesToHideProfileSelector: string[] = [
    '/autenticacion',
    '/afiliacion-empresa',
  ];

  constructor(private router: Router) {}

  ngOnInit() {
    this.router.events.subscribe((event: Event) => {
      if (
        event instanceof NavigationStart ||
        event instanceof NavigationCancel
      ) {
        this.canBeShown = this.profileCanBeSelected(event.url);
      }
    });
  }

  profileCanBeSelected(url: string): boolean {
    if (url.split('?').length > 1) {
      return !(
        this.routesToHideProfileSelector.indexOf(url.split('?')[0]) > -1
      );
    }
    return !(this.routesToHideProfileSelector.indexOf(url) > -1);
  }
}
